import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import { useGetCustomerQuery } from "../../api/customerApi";
import { ChannelLanguagePair } from "../product";
import { RootState } from "../../utils/store";
import { ProofreadRequestModal } from "./ProofreadRequestModal";
import {
  sendBulkToProofreading,
  SendToProofreadingRequest,
  SendToProofreadingResponse,
} from "./proofreadActions";

type Props = {
  dialogRef: React.RefObject<HTMLDialogElement>;
  /** Selection bucket holding the document ids to send to proofreading. */
  bucket: string;
};

/**
 * "Send to proofreading" bulk action for the Document list. The selected
 * documents are resolved server-side from the selection bucket; the available
 * channel/language pairs come from the customer defaults since the selection
 * can span many products.
 */
export const BulkProofreadRequestModal: React.FC<Props> = ({
  dialogRef,
  bucket,
}) => {
  const token = useSelector((state: RootState) => state.auth.token);
  const { data: customer } = useGetCustomerQuery();

  const availablePairs = useMemo<ChannelLanguagePair[]>(() => {
    if (!customer) return [];
    return customer.channel_language_pairs
      .filter((p) => p.default)
      .map((p) => new ChannelLanguagePair(p.language_code, p.channel_id));
  }, [customer]);

  const submit = (
    payload: SendToProofreadingRequest
  ): Promise<SendToProofreadingResponse> =>
    sendBulkToProofreading(token, { ...payload, bucket });

  return (
    <ProofreadRequestModal
      dialogRef={dialogRef}
      availablePairs={availablePairs}
      submit={submit}
    />
  );
};
